import { CallFailureType } from "@/types/call.types";

import { CallSessionId, CallState } from "./call-state.types";

export enum TelephonyEventType {
    PROVIDER_INITIALIZED = "PROVIDER_INITIALIZED",
    PROVIDER_DESTROYED = "PROVIDER_DESTROYED",
    CALL_CONNECTING = "CALL_CONNECTING",
    CALL_RINGING = "CALL_RINGING",
    CALL_CONNECTED = "CALL_CONNECTED",
    CALL_DISCONNECTED = "CALL_DISCONNECTED",
    CALL_FAILED = "CALL_FAILED",
    CALL_MUTE_CHANGED = "CALL_MUTE_CHANGED",
    AUDIO_LEVEL_UPDATED = "AUDIO_LEVEL_UPDATED",
}

export type TelephonyEvent =
    | { type: TelephonyEventType.PROVIDER_INITIALIZED; providerId: "twilio" | "vonage" }
    | { type: TelephonyEventType.PROVIDER_DESTROYED; providerId: "twilio" | "vonage" }
    | { type: TelephonyEventType.CALL_CONNECTING; sessionId: CallSessionId; state: CallState }
    | { type: TelephonyEventType.CALL_RINGING; sessionId: CallSessionId; state: CallState }
    | { type: TelephonyEventType.CALL_CONNECTED; sessionId: CallSessionId; state: CallState }
    | { type: TelephonyEventType.CALL_DISCONNECTED; sessionId: CallSessionId; state: CallState }
    | { type: TelephonyEventType.CALL_FAILED; sessionId: CallSessionId; failureType: CallFailureType; state: CallState }
    | { type: TelephonyEventType.CALL_MUTE_CHANGED; sessionId: CallSessionId; muted: boolean }
    | { type: TelephonyEventType.AUDIO_LEVEL_UPDATED; levels: number[] };
